import getCssVariable from "./getCssVariable";

export function returnStatus(status) {
    if (status === "PEN") return { color: getCssVariable("--laranja-padrao"), title: "01 - Pendente" };
    if (status === "SEP") return { color: getCssVariable("--azul-padrao"), title: "02 - Separação de estoque" };
    if (status === "LIB") return { color: getCssVariable("--azul-escuro-padrao"), title: "03 - Liberado para entrega" };
    if (status === "ROT") return { color: getCssVariable("--amarelo-padrao"), title: "04 - Em rota" };
    if (status === "ENT") return { color: getCssVariable("--verde-padrao"), title: "05 - Entregue" };
    if (status === "CAN") return { color: getCssVariable("--vermelho-padrao"), title: "06 - Cancelado" };
}

export function formatarPagamentos(pg, troco) {
    return pg.filter(x => !!x.modalidadeId).map(x => ({ ...x, recebido: x.tipo == "troco" ? x.recebido - troco : x.recebido }));
}

export function formatarCorPorValorMovimentacao(valor) {

    if (valor > 0)
        return getCssVariable("--azul-padrao");
    else if (valor < 0)
        return getCssVariable("--vermelho-padrao");
    else
        return getCssVariable("--laranja-padrao");
}

export function formatarCpfCnpj(str) {
    return str?.length == 11 ? str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function formatarTelefone(str) {
    if (str?.length === 10)
        return str.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    else if (str?.length === 11)
        return str.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    else
        return str;
}


export const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);